


import AccountHead from "../components/account/header";
import '../App.css';
import logodark from "../karuncup-dark-1.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {jwtDecode} from "jwt-decode";
import axios from "axios";
import { NewsBoxUser } from "../components/BoxNews";
import API,{createAxiosHeaders} from "../utils/api";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Person4Icon from '@mui/icons-material/Person4';
import { useSnackbar } from "notistack";
import FileUploader from "../components/submission";
import payApi from "../utils/payApi";
import Payment from "../components/Payment";
import DavarPanel from '../components/DavarScoringUI';
import LeaderboardPanel from "../components/Leaderboard";
import Sidebar from "../components/Sidebar";

const Profile = () => {
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);
  const [leagueData, setLeagueData] = useState(null);
const [disabledLeaderboard, setDisabledLeaderboard] = useState(false);
  const [error, setError] = useState(null); // State for errors
  const [teamMembers, setTeamMembers] = useState([]);
  const [hasPaid, setHasPaid] = useState(null);  // وضعیت پرداخت
  const [transactions,setTransactions] = useState([]);
  const [notification, setNotification] = useState(null);
  const [showNotification, setShowNotification] = useState(false);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  
  const fetchTeamMembers = async (userData) => {
    try {
        const headers = createAxiosHeaders();
        const response = await API.get(`${process.env.REACT_APP_BACKEND_URL}/api/team-members/get/${userData.email}`,headers); // Endpoint to fetch members
        setTeamMembers(response.data);
    } catch (error) {
        enqueueSnackbar("عدم موفقیت در بارگذاری اعضای تیم", {
            variant: "error",
            action: (key) => (
              <IconButton onClick={() => closeSnackbar(key)}>
                <CloseIcon style={{ color: "white" }} />
              </IconButton>
            ),
          });
    }
};

  useEffect(() => {
    
    const token = localStorage.getItem("access_token");

    if (!token) {
      navigate("/");
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;

      if (decodedToken.exp < currentTime) {
        localStorage.removeItem("access_token");
        navigate("/");
        return;
      }

      const userId = decodedToken.user_id;

      axios
        .get(`${process.env.REACT_APP_BACKEND_URL}/api/users/${userId}/`, {
          headers: { Authorization: `Bearer ${token}` },
        })
        .then((response) => {
          const user = response.data;
          console.log(user);
          setUserData(user);
          if(user.role == "User"){
            fetchTeamMembers(user);
          }
          
          return axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/api/leagues/${user.league}/`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
        })
        .then((leagueResponse) => {
          setLeagueData(leagueResponse.data);
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setError("Failed to fetch user or league data.");
          navigate("/"); // Redirect if data fetching fails
        });
    } catch (error) {
      console.error("Error decoding token:", error);
      setError("Invalid or expired token.");
      navigate("/");
    }
   
  }, [navigate]);
  useEffect(() => {
    if (!userData) return;
    payApi.getPaymentStatus()
      .then(res => { setTransactions(res.data.transactions);

        
   
      })
      .catch(err => {
        console.error("Error fetching payment status:", err);
        setError("خطا در بررسی وضعیت پرداخت.");
      });

    // fetch active notification
    (async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/notification/`);
        const data = await res.json();
        const item = Array.isArray(data) ? data[0] : data;
        if (item && item.is_active) {
          setNotification(item);
          setShowNotification(true);
        }
      } catch (err) {
        console.error('Error fetching notification:', err);
      }
    })();

  }, [userData]);

  useEffect(() => {
    if (leagueData) {
      setDisabledLeaderboard(!leagueData.show_leaderboard);
           const successful = transactions.filter(tx => tx.status);
  const totalAmount = successful.reduce((sum, tx) => sum + tx.amount, 0);
  const allmem=teamMembers.length + 1;
  const tot = allmem * leagueData?.registration_fee;
  if(tot == totalAmount){
setHasPaid(true);
  }else{
    setHasPaid(false);
  }
    }
  }, [leagueData, transactions, teamMembers]);

  // ۴) اگر هنوز وضعیت پرداخت لود نشده
  if (hasPaid === null) return <div>در حال بررسی وضعیت پرداخت...</div>;

  if (hasPaid === false && userData.role === "User" && userData.is_preverified == true) {
    return (
      <div className="p-4">
        
          <>
          <div className="mt-6 text-right">
           
                    <h3>خرید بلیط ورودی برای اعضای تیم</h3>
                    <Payment
                      teamMembersCount={teamMembers.length}
                      pricePerMember={leagueData?.registration_fee}
                      transactions={transactions}
                    />
                  </div>
            <h2 className="text-xl font-semibold mb-4 text-slate-700">
              تراکنش‌های شما
            </h2>
            <div className="overflow-x-auto">
              <table className="table-auto w-full text-right">
                <thead>
                  <tr className="bg-lime-900 text-white">
                    <th className="px-4 py-2">مبلغ</th>
                    <th className="px-4 py-2">وضعیت</th>
                    <th className="px-4 py-2">تاریخ</th>
                  </tr>
                </thead>
                <tbody>
                  {transactions.map((tx, idx) => (
                    <tr
                      key={idx}
                      className={idx % 2 === 0 ? "bg-white/5" : "bg-white/10"}
                    >
                      <td className="border-t px-4 py-2">
                        {tx.amount != null ? tx.amount.toLocaleString() : "0"}
 تومان
                      </td>
                      <td className="border-t px-4 py-2">
                        <span
                          className={`inline-block px-2 py-1 text-xs font-medium rounded-full ${
                            tx.status
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}
                        >
                          {tx.status ? "موفق" : "ناموفق"}
                        </span>
                      </td>
                      <td className="border-t px-4 py-2">
                        {new Date(tx.created_at).toLocaleString("fa-IR")}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <aside
        dir="rtl"
        className="group/sidebar flex flex-col shrink-0 lg:w-[300px] w-[250px] transition-all duration-300 ease-in-out m-0 fixed z-40 inset-y-0 right-0 bg-slate-800 border-r border-r-dashed border-r-slate-500 sidenav fixed-start loopple-fixed-start"
        id="sidenav-main"
      >
        <div className="flex shrink-0 px-8 items-center justify-between h-[96px]">
          <a
            className="mx-auto transition-colors duration-200 ease-in-out"
            href="https://www.loopple.com"
          >
            <img
              alt="Logo"
              src={logodark}
              width="96"
              height="96"
              className="mb-3 mx-auto"
            />
          </a>
        </div>
        <div className="flex items-center justify-between px-8 py-5">
      <div className="flex items-center mr-5">
      <div className="mr-5">
          <div className="inline-block relative shrink-0 cursor-pointer rounded-[.95rem]">
          <img className="w-[52px] h-[52px] shrink-0 inline-block rounded-[.95rem]" src={`${userData.teampic}`} alt="avatar image" />
          </div>
      </div>
      <div className="mr-2 ">
          <a href="javascript:void(0)" className="text-sm whitespace-nowrap text-lime-500 hover:text-lime-500 transition-colors duration-200 ease-in-out text-[1.075rem] font-medium dark:text-neutral-400/90 text-secondary-inverse">{userData.firstname} {userData.lastname}</a>
          <span className="mr-2 text-slate-300 dark:text-stone-500 font-medium block text-[0.85rem]">{userData.teamrole}</span>
      </div>
      </div>
      <a className="inline-flex relative items-center group justify-end text-base font-medium leading-normal text-center align-middle cursor-pointer rounded-[.95rem] transition-colors duration-150 ease-in-out text-slate-300 bg-transparent shadow-none border-0" href="javascript:void(0)">
      <span className="leading-none transition-colors duration-200 ease-in-out peer shrink-0 group-hover:text-lime-500">
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" className="w-6 h-6">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007-.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z"></path>
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
          </svg>
      </span>
      </a>
  </div>
        <div className="border-b border-dashed  border-slate-900"></div>

        <div className="relative pl-3 my-5 overflow-y-scroll">
          <div className="flex flex-col w-full font-medium">
            <div>
              <span className="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]">
                <a
                  onClick={()=>{navigate('/add-team')}}
                  className="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-slate-500 hover:text-cyan-500 transition-colors"
                >
                  افزودن اعضای تیم
                </a>
              </span>
            </div>
            {hasPaid ? (<div>
              <span className="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]">
                <a
                  href="/certificate"
                  className="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-slate-500 hover:text-cyan-500 transition-colors"
                >
                  دریافت گواهی
                </a>
              </span>
            </div>) : (<></>)}
            {hasPaid ? (<div>
              <span className="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]">
                <a
                  href="/invoice"
                  className="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-slate-500 hover:text-cyan-500 transition-colors"
                >
                 دریافت فاکتور
                </a>
              </span>
            </div>) : (<></>)}
            
            <div>
              <span className="select-none flex items-center px-4 py-[.775rem] cursor-pointer my-[.4rem] rounded-[.95rem]">
                <a
                  onClick={()=>{navigate('/Logout')}}
                  className="flex items-center flex-grow text-[1.15rem] dark:text-neutral-400/75 text-slate-500 hover:text-cyan-500 transition-colors"
                >
                 خروج
                </a>
              </span>
            </div>
            {/* Add other menu links */}
            <div className="block pt-5 pb-[.15rem]">
              <div className="px-4 py-[.65rem]">
                <span className="font-semibold text-[0.95rem] uppercase dark:text-neutral-500/80 text-slate-600">
                  لیگ {leagueData?.name}
                </span>
              </div>
            </div>
          </div>
        </div>
      </aside>
          </>
        
      </div>
    );
  }
  if (error) {
    return <div className="text-red-500">{error}</div>;
  }

  if (!userData) {
    return <div>Loading...</div>;
  }
  
  
if(userData.role === "User"){
  return (
    <div className="bg-slate-900 flex flex-col items-center justify-center text-slate-600">
      <AccountHead userData={userData} />
      {showNotification && notification && (
        <div className="w-full mb-2 max-w-3xl bg-slate-800 text-white rounded-md p-4 mt-6 shadow flex flex-row-reverse items-start justify-between gap-4">
          <div>
            <h4 className="font-bold">{notification.title}</h4>
            <p className="mt-1 text-sm">{notification.body}</p>
          </div>
          <div>
            <IconButton  onClick={() => setShowNotification(false)} aria-label="close" size="small">
              <CloseIcon className="text-white/50" />
            </IconButton>
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 ">
        <div className="flex flex-col">
          {!disabledLeaderboard ? (
          <LeaderboardPanel leagueId={leagueData?.id} leagueName={leagueData?.name} />
        ) : (
          <p className="p-1 text-center text-gray-100 border-2 border-slate-300/70 rounded-md mb-4">لیست تیم های برتر برای این لیگ غیرفعال است</p>
        )}
      <NewsBoxUser leagueID={leagueData?.id}/>
        </div>
        
        
        <div className="col-span-1 w-full max-w-lg p-6 border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
          <div className="flex flex-col items-center pb-10">
            <img
              src={`${userData?.teampic}`}
              alt="User Icon"
              width="96"
              height="96"
              className="mb-3 rounded-full shadow-lg"
            />
            <h5 className="mb-1 text-xl font-medium text-lime-500 dark:text-white">
              {userData?.teamname
                ? ` ${userData?.teamname} نام تیم`
                : "بدون نام تیم"}
                
            </h5>
            <span className="text-sm text-gray-500 dark:text-gray-400">
              {userData?.email}
            </span>
          
          </div>
          <section dir="rtl">
          <h2 className="p-1 bg-slate-700 text-white w-fit">اعضای تیم</h2>
          <ul>
                  <li  className="relative w-fit p-2 text-xl">
                     <Person4Icon /> {userData?.firstname} {userData?.lastname}   <div className="inline-flex items-center justify-center p-1 px-2 font-light text-xs  text-white bg-slate-700 rounded-md mr-2 ">لیدر</div>
                  </li>
              {teamMembers.map((member) => (
                  <li key={member.id} className="relative w-fit p-2 text-xl">
                     <Person4Icon /> {member.firstname} {member.lastname}   <div className="inline-flex items-center justify-center p-1 px-2 font-light text-xs  text-white bg-slate-700 rounded-md mr-2 ">{member.expert}</div>
                  </li>
              ))}
          </ul>   
          {leagueData?.allow_file_submission && (
  <>
    <h2 className="p-1 bg-slate-700 text-white w-fit">ارسال فایل برای داور</h2>
    <a href="/terms" className="text-sm animate-pulse text-yellow-400 p-2 text-center"> فایل نمونه پروپوزال از سربرگ قوانین بالای صفحه نخست دانلود کنید.</a>
    <FileUploader />
  </>
)}
          
        </section>
        
        </div>
        <Sidebar
        userData={userData}
        hasPaid={hasPaid}
        leagueData={leagueData}
        navigate={navigate}
      />
      </div>
     
    </div>
    
  );
}else if(userData.role === "davar"){
  return (
    <div className="bg-slate-900">
    <div className="w-fit mx-auto p-2 ">
<AccountHead userData={userData} />
    </div>
    
    <div className=" grid grid-cols-1 md:grid-cols-3  text-slate-600">
        {!disabledLeaderboard ? (
          <LeaderboardPanel leagueId={leagueData.id} leagueName={leagueData.name} />
        ) : (
          <p className="p-1 text-center text-gray-100 border-2 border-slate-300/70 rounded-md mb-4">لیست تیم های برتر برای این لیگ غیرفعال است</p>
        )}
     
     <DavarPanel
  userData={userData}
  leagueData={{
    ...leagueData,
    submissions: leagueData.submissions || [],   // <-- اینجا
    scores: leagueData.scores || []              // <-- یا هر آرایهٔ دیگری
  }}
/>
       <Sidebar
        userData={userData}
        hasPaid={hasPaid}
        leagueData={leagueData}
        navigate={navigate}
      />
    </div>
    </div>
  );
}

  
};

export default Profile;
